import { makeTypedEvent } from 'modules/core/lib/Tracking/typedEvents'

export const FAVORITE_EVENTS = {
  navigate: makeTypedEvent<{ url: string; label: string }>('Navigate from favorites list'),
  add: makeTypedEvent<{ url: string; label: string }>('Add resource to favorites'),
  remove: makeTypedEvent<{ url: string; label: string }>('Remove resource from favorites'),
  reorder: makeTypedEvent('Reorder sidebar favorites'),
}
